import { TemplateConfig } from '../../template-config.interface';

export const macroGIF: TemplateConfig = {
  id: 'macro-gif',
  clientId: 'MACRO',
  title: 'Macro GIF',
  description: 'Template para contenido GIF',
  aspectRatio: 'square',
  image: 'https://media.backend.doer.ar/brands/assets/MACRO/templates/macro-gif/thumbnails/macro-gif.png',
  optimized_image:
    'https://media.backend.doer.ar/brands/assets/MACRO/templates/macro-gif/thumbnails/optimized/macro-gif.png',
  video: 'https://media.backend.doer.ar/brands/Ejemplos/prueba1.gif',
  video_1080x1080: 'https://media.backend.doer.ar/brands/Ejemplos/prueba1.gif',

  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'text1',
      label: 'Slogan',
      type: 'input',
      placeholder: 'Máx. 20 caracteres por línea. Presioná Enter para saltos de línea.',
      required: true,
      multiline: true,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/ctv/description.png'
    },
    {
      key: 'image1',
      label: 'Imagen principal',
      type: 'visual-select',
      required: false,
      options: [
        {
          id: 'MAG7Z7hv1iQ',
          value: 'MAG7Z7hv1iQ', // Lo que se envía al backend
          label: '1',
          imageUrl: 'https://media.backend.doer.ar/brands/assets/MACRO/templates/thumbnails/macro-gif/MAG7Z7hv1iQ.png',
          backgroundColor: '#0139E3'
        },
        {
          id: 'MAG7Z9KCteA',
          value: 'MAG7Z9KCteA', // Lo que se envía al backend
          label: '2',
          imageUrl: 'https://media.backend.doer.ar/brands/assets/MACRO/templates/thumbnails/macro-gif/MAG7Z9KCteA.png',
          backgroundColor: '#0139E3'
        },
        {
          id: 'MAG7Z8xs-SA',
          value: 'MAG7Z8xs-SA',
          label: '3',
          imageUrl: 'https://media.backend.doer.ar/brands/assets/MACRO/templates/thumbnails/macro-gif/MAG7Z8xs-SA.png',
          backgroundColor: '#0139E3'
        }
      ],
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/ctv/logo.png'
    }
  ],

  promptTemplate: '',
  hidePromptTemplate: true
};
